var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0322 13.7977C18.119 13.7977 19 14.704 19 15.8221V16.34C19 17.1451 18.7203 17.9235 18.2115 18.5351C16.8382 20.1855 14.7495 21 11.9971 21C9.2444 21 7.15658 20.1853 5.78602 18.5341C5.27871 17.923 5 17.1457 5 16.342V15.8221C5 14.704 5.88102 13.7977 6.96783 13.7977H17.0322ZM17.0322 15.148H6.96783C6.60592 15.148 6.31254 15.4498 6.31254 15.8221V16.342C6.31254 16.8242 6.47977 17.2906 6.78416 17.6573C7.88083 18.9784 9.60103 19.6498 11.9971 19.6498C14.3932 19.6498 16.1149 18.9784 17.2144 17.6571C17.5197 17.2901 17.6875 16.823 17.6875 16.34V15.8221C17.6875 15.4498 17.3941 15.148 17.0322 15.148ZM11.9971 3C14.4135 3 16.3723 5.01508 16.3723 7.5008C16.3723 9.98654 14.4135 12.0016 11.9971 12.0016C9.5808 12.0016 7.62199 9.98654 7.62199 7.5008C7.62199 5.01508 9.5808 3 11.9971 3ZM11.9971 4.35024C10.3057 4.35024 8.93453 5.7608 8.93453 7.5008C8.93453 9.24082 10.3057 10.6514 11.9971 10.6514C13.6886 10.6514 15.0597 9.24082 15.0597 7.5008C15.0597 5.7608 13.6886 4.35024 11.9971 4.35024Z",
    fill: "#414548"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/Person.c8d6192b16d8343a32c77a782a097943.svg";
export { ForwardRef as ReactComponent };